const React = require('react');

module.exports = ({className, ...props}) => (
  <div
    {...props}
    className={`wmax50% wmax100%@m w ph29` + (className ? ` ${className}` : '')}
  />
);
